import { configureStore } from '@reduxjs/toolkit';
import Normal from './Normal/reducer';
import NormalT from './NormalT/reducer'; 
import GDS from './GDS/reducer'; //TODO: 第二階段融合到Normal
import GDST from './GDST/reducer'; //TODO: 第二階段融合到NormalT
import THSR from './THSR/reducer';
import Common from './Common/reducer';

export const store = configureStore({
    reducer: {
        Normal,
        NormalT,
        GDS,
        GDST,
        THSR,
        Common,
    },
});

export type RootState = ReturnType<typeof store.getState>;
